import React from 'react';
import { connect } from 'react-redux';
import RequireRoleBase from '../components/RequireRoleBase';

const mapStateToProps = state => {
  const auth = state.user || {};
  return {
    isLoggedIn: auth.loggedIn,
    currentUserRole: auth.roleId || 0,
    isAdmin: auth.isAdmin || false
  };
};

const RequireRoleConnected = connect(mapStateToProps)(RequireRoleBase);
export const RequireRole = (WrappedComponent, requireRoleProps = {}) => {
  return function(props) {
    return (
      <RequireRoleConnected {...requireRoleProps}>
        <WrappedComponent {...props} />
      </RequireRoleConnected>
    );
  };
};